import {Component, OnInit, OnDestroy,ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import {Column, GridOption, AngularGridInstance, Formatters,OnEventArgs} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-check-list',
  templateUrl: './check-list.component.html',
  styleUrls: ['./check-list.component.css']
})
export class CheckListComponent implements OnInit, OnDestroy {
    description: string;
    clientId: number;
    ttypes = [];
    ticketSelected: number;
    ticketTypeId: number;
    categoryLoaded: boolean;
    private baseCategories = [];
    ticketTypes: any;
    cat = [];
    dynamicFields = [];
    priorityType: number;
    columnDefinitions = [];
    ticketType: string;
    ticketTypeSeqNo: number;
    ticket_status = [];
    ststusSelected: number;
    ticketStatus: string;
    status_sequence: number;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;

    isError = false;
    errorMessage: string;
    respObject: any;
    totalData: number;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    private notifier: NotifierService;
    offset: number;
    types = [];
    typeSelected: number;
    ticketFieldTicketName = '';
    isDropdown: boolean;
    dropdown = '';
    isCategory: boolean;
    isStatus: boolean;
    dataLoaded:boolean; 
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    checkList: any;
    items: any;
    // userId: number;
    type: string;
    dataArr:any;
    showExportBtn = true;
    dataExcel = [];
    isExportDisable = false;

    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;


    @ViewChild('content1') private content1;
    private modalReference: NgbModalRef;
    selectedId:any;
    typeName:any;
    catName:any;
    statusName:any;




    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // item.createdBy = this.messageService.getUserId();
                            // if (item.description !== '') {
                            //     this._rest.editChecklist(item).subscribe((res) => {
                            //         this.respObject = res;
                            //         if (this.respObject.success) {
                            //             // console.log('data--Done');
                            //             this.notifier.notify('success', 'Updated successfully');
                            //         } else {
                            //             // console.log('data--Not---Done');
                            //             this.notifier.notify('error', this.respObject.errorMessage);
                            //         }
                            //     }, (err) => {
                            //         this.notifier.notify('error', JSON.stringify(err));
                            //     });
                            // } else {
                            //     this.notifier.notify('error', this.messageService.BLANK_ERROR_MESSAGE);
                            // }
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteChecklist({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
            }
        });

    }

  ngOnInit() {
      this.dataLoaded=false
      this.isCategory = false;
      this.isStatus = false;
      this.description = '';
      this.categoryLoaded = true;
      this.ticketSelected = 0;
      this.nextOffset = 0;
      this.previousOffset = 0;
      this.pageSize = this.messageService.pageSize;
      this.page_no = 0;
      this.totalPage = 0;
      this.displayData = {
          pageName: ' Maintain Check List',
          openModalButton: 'Add Check List',
          searchModalButton: 'Search',
          breadcrumb: 'Check List',
          folderName: 'All Check List',
          tabName: 'Check List',
          exportBtn: 'Export to excel',

      };

      this.types = [{id: 1, name: 'text'}, {id: 2, name: 'date'}, {id: 3, name: 'dropdown'}, {id: 4, name: 'textarea'}];

      this.typeSelected = 1;

      this.columnDefinitions = [
          {
              id: 'delete',
              field: 'id',
              excludeFromHeaderMenu: true,
              formatter: Formatters.deleteIcon,
              minWidth: 30,
              maxWidth: 30,
          },
          {
            id: 'edit',
            field: 'id',
            excludeFromHeaderMenu: true,
            formatter: Formatters.editIcon,
            minWidth: 30,
            maxWidth: 30,
            onCellClick: (e: Event, args: OnEventArgs) => {
                console.log(args.dataContext);
                this.selectedId = args.dataContext.id;
                this.typeSelected = Number(args.dataContext.fieldType_id);
                if (Number(this.typeSelected) === 3) {
                    this.isDropdown = true;
                  } else {
                    this.isDropdown = false;
                  }
                this.description = args.dataContext.description;
                this.dropdown = args.dataContext.predifinedValue;
                this.typeName = args.dataContext.ticketType;
                this.catName = args.dataContext.category;
                this.statusName = args.dataContext.ticketStatus;
                this.modalReference = this.modalService.open(this.content1, {});
                this.modalReference.result.then((result) => {
                }, (reason) => {
    
                });
            }
        },
    
          {
              id: 'ticketType', name: 'Ticket Type', field: 'ticketType', sortable: true, filterable: true, width: 40
          },
          {
              id: 'category', name: 'Category', field: 'category', sortable: true, filterable: true, width: 130
          },
          {id: 'status', name: 'Status', field: 'ticketStatus', sortable: true, filterable: true},
          {
              id: 'description', name: 'Checklist Item', field: 'description', sortable: true, filterable: true, width: 150
          },
          {id: 'type', name: 'Type', field: 'fieldType', sortable: true, filterable: true},
          {
              id: 'dropdownValue', name: 'DropDown Value', field: 'predifinedValue', sortable: true, filterable: true, width: 150
          }
      ];
      this.messageService.setColumnDefinitions(this.columnDefinitions);
      if (this.messageService.clientId) {
          this.clientId = this.messageService.clientId;
          this.baseFlag = this.messageService.baseFlag;
          this.onPageLoad();
      } else {
          this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
              this.view = auth[0].viewFlag;
              this.add = auth[0].addFlag;
              this.edit = auth[0].editFlag;
              this.del = auth[0].deleteFlag;
              this.clientId = auth[0].clientId;
              this.baseFlag = auth[0].baseFlag;
              this.onPageLoad();
          });
      }
      this.searchData.valueChanges.subscribe(
        name => {
            if (name.length > 4) {
                this.isLoading = true
                this._rest.searchAllTicketCheckList( name, this.clientId).subscribe((res1) => {
                    this.respObject = res1;
                    this.isLoading = false;
                    if (this.respObject.success) {
                        this.items = this.respObject.details;
                        // console.log("true"+ JSON.stringify(this.items));
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                }, (err) => {
                    this.isLoading = false;
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                });
            } else {
                this.items = [];
            }
        });
  }

    onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.ttypes = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();
    }

    onTicketChange(selectedIndex: any) {
        this.ticketTypeId = this.ttypes[selectedIndex].id;
        this.ticketType = this.ttypes[selectedIndex].name;
        this.ticketTypeSeqNo = this.ttypes[selectedIndex].seq;
        this._rest.getStatusByTicketTypeLt(this.ticketTypeSeqNo, this.clientId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.isStatus = true;
                this.respObject.details.unshift({id: 0, status: 'Select Ticket Status'});
                this.ticket_status = this.respObject.details;
                console.log('status==========' + this.ticket_status);
                this.ststusSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this._rest.getTicketCreateLoadingDtls(this.messageService.getUserId(), this.ticketTypeId, this.clientId).subscribe((res) => {
            this.respObject = res;
            this.categoryLoaded = true;
            if (this.respObject.success) {
                this.isCategory = true;
                // this.baseCategories = JSON.parse(JSON.stringify(this.respObject.details[0].attribute));
                this.baseCategories = this.messageService.copyArray(this.respObject.details[0].attribute);
                this.ticketTypes = this.respObject.details[0].attribute;
                // this.priorityType = this.respObject.details[0].val.type;
                this.cat = [];
                // this.clientId = this.respObject.details[0].clientId;
                // this.respObject.details[0].val.urgency.unshift({
                //     id: 0,
                //     name: 'Select Urgency'
                // });
                // this.respObject.details[0].val.impact.unshift({
                //     id: 0,
                //     name: 'Select Bussiness Impact'
                // });
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    onStatusChange(selectedIndex: any) {
        this.ticketStatus = this.ticket_status[selectedIndex].status;
        this.status_sequence = this.ticket_status[selectedIndex].sequence;
    }



    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    exportToExcel() {
        this.isExportDisable =true ;
        // console.log("okkk" +this.clientId);
        this._rest.getAllTicketCheckList(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isExportDisable =false;
                this.dataExcel = this.respObject.details;
                // console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.description = '';
            this.ticketTypes = [];
            this.ticketSelected = 0;
            this.modalService.open(content , {size: 'lg'}).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    searchModal()  {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.description = '';
            this.ticketTypes = [];
            this.ticketSelected = 0;
            this.type = '';
            this.checkList = '';
            this.searchModalReference = this.modalService.open(this.scarch_content);
            this.searchModalReference.result.then((result) => {
            }, (reason) => {

            });
        }
    }

    getDetails() {
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].description === this.checkList) {
                for (let j = 0; j < this.types.length; j++) {
                    if (this.items[i].fieldType === this.types[j].id.toString()) {
                        this.items[i].fieldType = this.types[j].name;
                        this.type = this.items[i].fieldType;
                        break;
                    }
                }
            }
        }
    }
    search() {
      const data1 = [];
      for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].description === this.checkList) {
            data1.push(this.items[i]);
          }
      }
      this.page_no = 1;
      this.messageService.setTotalData(data1.length);
      this.messageService.setGridData(data1);
      this.searchModalReference.close();

    }


    onCategoryChange(ticket, option) {
        // console.log('+++++++++++++++++++++', JSON.stringify(ticket), typeof option, ticket.id);
        const opt = JSON.parse(option);
        // console.log('++++++++++++++' + JSON.stringify(opt));
        if (opt.type !== 'header') {
            // if (this.attachment.length > 0) {
            //     this.attachment = [];
            // }
            const value = opt.id;
            const catVal = opt.title;
            let matched = false;
            const index = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id + 1);
            // console.log('index:' + index);
            const index1 = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id);
            const pid = this.ticketTypes[index1].options[0].id;
            // console.log(this.ticketTypes[index1].options[0]);
            if (this.cat.length === 0) {
                this.cat.push({pid: pid, cid: value, catName: catVal});
            } else {
                for (let i = 0; i < this.cat.length; i++) {
                    if (this.cat[i].pid === pid) {
                        matched = true;
                        this.cat[i].cid = value;
                        this.cat[i].catName = catVal;
                        break;
                    }
                }
                if (!matched) {
                    this.cat.push({pid: pid, cid: value, catName: catVal});
                } else {
                    for (let i = index; i < this.cat.length; i++) {
                        // console.log('matched');
                        // console.log(this.cat[i]);
                        if (index > -1) {
                            this.cat[i].cid = 0;
                        }
                    }
                }
            }
            // clear sub categories
            if (index > -1) {
                // console.log('index:' + index);
                for (let i = index + 1; i < this.ticketTypes.length; i++) {
                    const options = this.ticketTypes[i].options;
                    // console.log(JSON.stringify(options));
                    for (let j = 0; j < options.length; j++) {
                        if (options[j].type) {
                            // options=[];
                            this.ticketTypes[i].options = [options[j]];
                            break;
                        }
                    }
                }
            }
            this._rest.getAttributesParentWise(this.clientId, value).subscribe((res) => {
                this.respObject = res;
                // console.log(JSON.stringify(this.respObject));
                let data;
                if (index > -1) {
                    data = this.ticketTypes[index].options[0];
                }
                if (this.respObject.success) {
                    // data = this.ticketTypes[index].options[0];
                    this.respObject.details.unshift(data);
                    this.ticketTypes[index].options = this.respObject.details;
                } else {
                    if (index > -1) {
                        this.ticketTypes[index].options = [data];
                    }
                    // this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
    }

    save() {
        let cats = '';
        let categoryName = ''
        let isError = false;
        const assetIds = [];
        // console.log('cat===' + JSON.stringify(this.cat));
            for (let i = 0; i < this.cat.length; i++) {
                if (this.cat[i].cid !== 0) {
                    cats += this.cat[i].cid;
                    if (i !== this.cat.length - 1) {
                        cats += ',';
                    }
                    if (categoryName === '') {
                        categoryName = this.cat[i].catName;
                    } else {
                        categoryName += ' / ' + this.cat[i].catName;
                    }
                    // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
                } else {
                    isError = true;
                    break;
                }
            }
            // console.log('######################===' + categoryName);
        const data = {
            clientId: this.clientId, description: this.description, category_id: cats,
            tickettype_id: this.ticketTypeId, status: this.ststusSelected, status_sequence: this.status_sequence,
            createdBy: this.messageService.getUserId(), fieldType: this.typeSelected
        };
        if (Number(this.typeSelected) === 3) {
          data['predifinedValue'] = this.dropdown;
        }
        if (!this.messageService.isBlankField(data)) {
            this._rest.addChecklist(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    const id = this.respObject.details;
                    this.messageService.setRow({
                        id: id,
                        ticketType: this.ticketType,
                        category: categoryName,
                        description: this.description,
                        ticketStatus: this.ticketStatus
                    });
                    this.totalData = this.totalData + 1;
                    this.messageService.setTotalData(this.totalData);
                    if (this.totalData <= this.pageSize * this.page_no) {
                        this.offset = id;
                        this.nextOffset = 0;
                    } else {
                        this.nextOffset = this.offset;
                    }
                    this.description = '';
                    this.dropdown = '';
                    this.typeSelected = 1;
                    this.isDropdown = false;
                    this.isCategory = false;
                    this.isStatus = false;
                    this.ticketSelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                // this.isError = true;
                // this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }



    update(){

        const data = {
            id:this.selectedId,
            clientId: this.clientId, description: this.description,
            createdBy: this.messageService.getUserId(), fieldType: this.typeSelected
        };
        if (Number(this.typeSelected) === 3) {
          data['predifinedValue'] = this.dropdown;
        }
        if (!this.messageService.isBlankField(data)) {
            this._rest.editChecklist(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                // this.isError = true;
                // this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }


    }

    getTableData() {
        // console.log(this.messageService.view)
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getChecklist(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            for (let i = 0; i < this.respObject.details.dataObj.length; i++) {
                for (let j = 0; j < this.types.length; j++) {
                    if (this.respObject.details.dataObj[i].fieldType === this.types[j].id.toString()) {
                        this.respObject.details.dataObj[i].fieldType = this.types[j].name;
                        console.log('hello');
                        break;
                    }
                }
            }
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

    onTypeChange(selectedIndex: any) {
        this.ticketFieldTicketName = this.types[selectedIndex];
        if (Number(this.typeSelected) === 3) {
          this.isDropdown = true;
        } else {
          this.isDropdown = false;
        }
    }
  





}
